import { render, staticRenderFns } from "./CustomerRow.vue?vue&type=template&id=0f4a5836&scoped=true"
import script from "./CustomerRow.vue?vue&type=script&lang=js"
export * from "./CustomerRow.vue?vue&type=script&lang=js"
import style0 from "./CustomerRow.vue?vue&type=style&index=0&id=0f4a5836&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4a5836",
  null
  
)

export default component.exports